import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { IntegrationHomeButton } from '~/components/IntegrationHomeButton';
import { chatHooks } from '~/lib/chat-hooks';
import { chatStore } from '~/lib/stores/chat';
import { devPrompts } from '~/utils/landingPage';

interface InitialPromptsProps {
  onImportFigma?: () => void;
  onImportGithub?: () => void;
}

export const InitialPrompts = memo((props: InitialPromptsProps) => {
  const chatStarted = useStore(chatStore.started);

  const { onImportFigma, onImportGithub } = props;

  if (chatStarted) {
    return null;
  }

  return (
    <div className="relative flex flex-col gap-9 w-full max-w-4xl mx-auto flex justify-center mt-2 2xl:max-w-[70rem]">
      {import.meta.env.DEV && (
        <div className="flex justify-center text-sm gap-2">
          {devPrompts.map(({ text, prompt }, index) => {
            return (
              <button
                key={index}
                className="border border-bolt-elements-borderColor rounded-full bg-gray-50 hover:bg-gray-100 dark:bg-gray-950 dark:hover:bg-gray-900 text-bolt-elements-textSecondary hover:text-bolt-elements-textPrimary px-3 py-1 text-xs transition-theme"
                onClick={() => chatHooks.sendMessage?.(prompt ?? text)}
              >
                {text}
              </button>
            );
          })}
        </div>
      )}

      <div className="flex text-sm items-center align-baseline gap-4 justify-center">
        <p className="text-center text-bolt-elements-textSecondary">or import from</p>
        <div className="flex justify-center gap-3">
          <IntegrationHomeButton title="Figma" icon="i-bolt:logos-figma" onClick={() => onImportFigma?.()} />

          <IntegrationHomeButton title="GitHub" icon="i-bx:bxl-github" onClick={() => onImportGithub?.()} />
        </div>
      </div>
    </div>
  );
});
